import React from 'react';
import { Transition, Button, Icon, Modal, Popup } from 'semantic-ui-react';
import moment from 'moment';
import api from '../../../api';
import { base64toBlob } from '../../../utils/fileSaverHelper';
import { saveAs } from 'file-saver';

import './Notificacao.css';
import BotaoEditar from '../../layouts/BotaoEditar';

const tipoNotificacao = {
  DEFAULT: 'Padrão',
  VOTING_CREATED: 'Votação Criada',
  VOTING_CLOSED: 'Votação Finalizada',
  CONVOCATION: 'Convocação'
};

const ICONES = {
  DEFAULT: 'bell outline',
  VOTING_CREATED: 'calendar plus outline',
  VOTING_CLOSED: 'check circle outline',
  CONVOCATION: 'bullhorn',
};

const Notificacao = ({ notificacao, animation, sendAction, removeAction }) => {
  const getEnviarAction = (mobile = false) => (
    <Modal
      trigger={
        <Button positive icon labelPosition={undefined} aria-label="Enviar notificação">
          <Icon name="send" />{!mobile && ' Enviar'}
        </Button>
      }
      header='Confirmação'
      content={`Deseja mesmo enviar esta notificação para as unidades votantes?`}
      size="mini"
      actions={[
        { key: 'close', content: 'Não', className: 'btn-ui-1 btn-ui-1-basic' },
        { key: 'done', content: 'Sim', className: 'btn-ui-1', positive: true, onClick: () => sendAction(notificacao._id) }
      ]}
    />
  );

  const getRemoveAction = (mobile = false) => (
    <Modal
      trigger={
        <Button className="btn-ui-1 btn-ui-1-basic" icon aria-label="Remover notificação">
          <Icon name="trash alternate outline" />{!mobile && ' Remover'}
        </Button>
      }
      header='Confirmação'
      content={`Deseja mesmo remover esta notificação?`}
      size="mini"
      actions={[
        { key: 'close', content: 'Não', className: 'btn-ui-1 btn-ui-1-basic' },
        { key: 'done', content: 'Sim', className: 'btn-ui-1', positive: true, onClick: () => removeAction(notificacao._id) }
      ]}
    />
  );

  const onClickRel = async () => {
    const rel = await api.notificacao.relatorio(notificacao.condominio, notificacao._id);
    saveAs(await base64toBlob(rel, 'application/pdf'), 'relatorio-notificacao.pdf');
  };

  const enviada = !!notificacao.dataEnvio;
  const tipo = tipoNotificacao[notificacao.tipo] || 'Notificação';

  return (
    <Transition duration={!isNaN(animation) ? animation : 500} animation="fade up" transitionOnMount={true}>
      <article className="va-notif">
        <span className={`va-un-avatar ${enviada ? '' : 'rascunho'}`} aria-hidden="true">
          <Icon name={ICONES[notificacao.tipo] || 'bell outline'} />
        </span>

        <div className="va-notif-corpo">
          <header>
            <h3>{tipo}</h3>
            <span className={`va-recente-status ${enviada ? 'andamento' : 'bloqueada'}`}>{enviada ? 'Enviada' : 'Não enviada'}</span>
          </header>
          {notificacao.mensagem && (
            <p className="va-notif-mensagem">
              {notificacao.mensagem.length > 140 ? `${notificacao.mensagem.substr(0, 140)}…` : notificacao.mensagem}
            </p>
          )}
          <div className="va-notif-meta">
            <span>
              <Icon name="clock outline" />
              {enviada ? <>Enviada {moment(notificacao.dataEnvio).fromNow()} por {notificacao.usuario}</> : 'Ainda não enviada aos moradores'}
            </span>
            {notificacao.arquivo && (
              <a href={notificacao.arquivo.url} target="_blank" rel="noopener noreferrer"><Icon name="paperclip" />Arquivo</a>
            )}
            {notificacao.link && (
              <a href={notificacao.link} target="_blank" rel="noopener noreferrer"><Icon name="linkify" />Link</a>
            )}
          </div>
        </div>

        <div className="va-notif-acoes">
          <Popup
            content="Gerar relatório de envios desta notificação"
            position="top center"
            trigger={
              <Button color="blue" icon onClick={onClickRel} aria-label="Relatório de envios">
                <Icon name="clipboard outline" /><span className="va-notif-rotulo"> Relatório</span>
              </Button>
            }
          />
          {getEnviarAction()}
          <BotaoEditar to={`/condominios/${notificacao.condominio}/notificacoes/editar/${notificacao._id}`} dica="Editar notificação" />
          {getRemoveAction()}
        </div>
      </article>
    </Transition>
  );
};

export default Notificacao;
